export const siteName = 'lgeCWC';
export const defaultDesktopViewer = 'carousel';
export const loginBoxStyles = { width: 400, borderRadius: 16, padding: '56px 40px' };
export { LoginExtraForms, Login } from './components';
export const protocolHandler = true;
